import { render, staticRenderFns } from "./my-model.vue?vue&type=template&id=271246f3&"
import script from "./my-model.vue?vue&type=script&lang=ts&"
export * from "./my-model.vue?vue&type=script&lang=ts&"
import style0 from "./my-model.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports